import React, { Component } from 'react'

import ReactModal from 'react-modal'
import { get } from 'lodash'
import { getModal } from '../ModalRegistry'

import IconCloseThin from 'components/Icons/CloseThin'

import s from './Modal.scss'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

export default class Modal extends Component {
  modalCancel = (data = {}) => {
    const { modalId } = this.props.modal
    // If the data is an object, string, number or boolean. Resolve
    // This is used to ignore mouse click events
    if (['Object', 'String', 'Number', 'Boolean'].includes(data.constructor.name)) {
      this.props.rejectModal({ modalId, data })
    } else {
      this.props.rejectModal({ modalId })
    }
    this.props.hideModal({ modalId })
  }
  modalConfirm = (data = {}) => {
    const { modalId } = this.props.modal
    // If the data is an object, string, number or boolean. Resolve
    // This is used to ignore mouse click events
    if (['Object', 'String', 'Number', 'Boolean'].includes(data.constructor.name)) {
      this.props.resolveModal({ modalId, data })
    } else {
      this.props.resolveModal({ modalId })
    }
    this.props.hideModal({ modalId })
  }
  onRequestClose = () => {
    const { modal } = this.props
    if (!(modal.modalOptions && modal.modalOptions.noClickClose)) {
      this.modalCancel()
    }
  }
  renderContent() {
    // Get the modal from the modal registry and add the modal props.
    const { modal } = this.props
    let template = null
    if (modal.modalType) {
      const ModalTemplate = getModal(modal.modalType)
      if (ModalTemplate) {
        const additionalProps = {
          modalCancel: this.modalCancel,
          modalConfirm: this.modalConfirm,
        }
        const allProps = Object.assign({}, modal.modalProps, additionalProps)
        template = <ModalTemplate {...allProps} />
      }
    }
    return template
  }
  render() {
    const { modal, className } = this.props
    const isFullScreen = get(modal, 'modalOptions.fullScreen')
    const closeWhite = get(modal, 'modalOptions.closeWhite')
    const modalClasses = cn(
      'modal',
      sLay['layout-column'],
      { [s.fullScreen]: isFullScreen },
      { [s.standard]: !isFullScreen },
      className
    )

    const overlayClasses = cn(
      'modalOverlay',
      { [sLay['layout-align-center-center']]: !isFullScreen },
      { [sLay['layout-column']]: !isFullScreen },
      { [s.fullScreenOverlay]: isFullScreen }
    )
    return (
      <ReactModal
        closeTimeoutMS={isFullScreen ? 600 : 200}
        isOpen
        contentLabel={modal.modalType}
        onRequestClose={this.onRequestClose}
        className={modalClasses}
        overlayClassName={overlayClasses}
        appElement={document.getElementById('app')}
      >
        {modal.modalOptions && modal.modalOptions.hideClose ? null : (
          <a className={cn(s.button, { [s.closeWhite]: closeWhite })}>
            <IconCloseThin size={30} onClick={this.modalCancel} />
          </a>
        )}
        {this.renderContent()}
      </ReactModal>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/Modal/Modal.jsx